import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import type { TimelineItemTriggerProps } from '@rtkwlf/c3-recipes-timeline';
import type { BadgeRootProps } from '@rtkwlf/fenrir-react';
import { faCheck } from '@rtkwlf/pro-solid-svg-icons/faCheck';
import { faClock } from '@rtkwlf/pro-solid-svg-icons/faClock';
import { faEnvelope } from '@rtkwlf/pro-solid-svg-icons/faEnvelope';
import { faHourglass } from '@rtkwlf/pro-solid-svg-icons/faHourglass';
import { faPause } from '@rtkwlf/pro-solid-svg-icons/faPause';
import { faScroll } from '@rtkwlf/pro-solid-svg-icons/faScroll';
import type { SpidrState } from '@rtkwlf/track-public';

type SpidrStateToBadge = {
  [key in SpidrState]: {
    appearance: BadgeRootProps['appearance'];
    icon: IconDefinition;
    text: string;
  };
};

export const spidrStateToBadge: SpidrStateToBadge = {
  'In Progress': {
    appearance: 'info',
    icon: faClock,
    text: 'common.spidrStates.inProgress',
  },
  'Pending Customer': {
    appearance: 'warning',
    icon: faHourglass,
    text: 'common.spidrStates.pendingCustomer',
  },
  'On Hold': {
    appearance: 'danger',
    icon: faPause,
    text: 'common.spidrStates.onHold',
  },
  Delivered: {
    appearance: 'attention',
    icon: faEnvelope,
    text: 'common.spidrStates.delivered',
  },
  Complete: {
    appearance: 'success',
    icon: faCheck,
    text: 'common.spidrStates.complete',
  },
  Legacy: {
    appearance: 'default',
    icon: faScroll,
    text: 'common.spidrStates.legacy',
  },
};

type SpidrStateToTimeline = {
  [key in SpidrState]: {
    color: TimelineItemTriggerProps['color'];
    icon: IconDefinition;
    label: string;
  };
};

export const spidrStateToTimeline: SpidrStateToTimeline = {
  'In Progress': {
    color: 'blue',
    icon: faClock,
    label: 'common.spidrStates.inProgress',
  },
  'Pending Customer': {
    color: 'orange',
    icon: faHourglass,
    label: 'common.spidrStates.pendingCustomer',
  },
  'On Hold': {
    color: 'red',
    icon: faPause,
    label: 'common.spidrStates.onHold',
  },
  Delivered: {
    color: 'yellow',
    icon: faEnvelope,
    label: 'common.spidrStates.delivered',
  },
  Complete: {
    color: 'green',
    icon: faCheck,
    label: 'common.spidrStates.complete',
  },
  Legacy: {
    color: 'light-grey',
    icon: faScroll,
    label: 'common.spidrStates.legacy',
  },
};
